/* Find Deals screen */
import React, { useState, useEffect, Suspense } from "react";
import axios from "../../axios";
import Footer from "../../components/Common/Footer";
import { useHistory } from "react-router-dom";
import { FlareSharp } from "@mui/icons-material";
import "react-phone-number-input/style.css";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
let CheckOutComponent = React.lazy(() =>
    import(
        "../../brands/" +
            sessionStorage.getItem("customBrand") +
            "/components/CreateAccount/CheckOut"
    )
);
export default function App(props) {
    const [clientSecret, setClientSecret] = useState("");
    const [stripePromise, setStripePromise] = useState("");
    const [state, setState] = useState({
        modalBillingDetails: false,
        errorMessage: undefined,
    });
    const history = useHistory();
    let noStripeClientSecret = false;
    const [phoneNumberMismatch, setPhoneNumberMismatch] = useState(false);
    const [mismatchPhoneNumber, setMismatchPhoneNumber] = useState("");
    const [retryPhoneNumber, setRetryPhoneNumber] = useState("");
    const [checkingPhoneNumber, setCheckingPhoneNumber] = useState(false);

    const submitRequestSubscription = (phoneNumber) => {
        let BillingCycleRecurrence;
        !sessionStorage.getItem("daysofservice")
            ? (BillingCycleRecurrence = 0)
            : (BillingCycleRecurrence =
                  sessionStorage.getItem("daysofservice"));
        let data;
        sessionStorage.getItem("unit") !== "undefined"
            ? (data = {
                  VenueID: sessionStorage.getItem("venueID"),
                  ServicePlanID: sessionStorage.getItem("servicePlanID"),
                  UnitID_internal: sessionStorage.getItem("unit"),
                  EmailAddress: sessionStorage.getItem("email").trim(),
                  GivenName: sessionStorage.getItem("firstName").trim(),
                  FamilyName: sessionStorage.getItem("lastName").trim(),
                  PhoneNumber: phoneNumber.trim(),
                  locale: "en-us",
                  contactpref_sms: sessionStorage.getItem("sms"),
                  "StartDateTimeUTC.ISO8601": new Date(
                      sessionStorage.getItem("dateStart")
                  ).toISOString(),
                  "EndDateTimeUTC.ISO8601": "",
                  BillingCycleRecurrence: BillingCycleRecurrence,
              })
            : (data = {
                  VenueID: sessionStorage.getItem("venueID"),
                  ServicePlanID: sessionStorage.getItem("servicePlanID"),
                  EmailAddress: sessionStorage.getItem("email").trim(),
                  GivenName: sessionStorage.getItem("firstName").trim(),
                  FamilyName: sessionStorage.getItem("lastName").trim(),
                  PhoneNumber: phoneNumber.trim(),
                  locale: "en-us",
                  contactpref_sms: sessionStorage.getItem("sms"),
                  "StartDateTimeUTC.ISO8601": new Date(
                      sessionStorage.getItem("dateStart")
                  ).toISOString(),
                  "EndDateTimeUTC.ISO8601": "",
                  BillingCycleRecurrence: BillingCycleRecurrence,
              });

        setCheckingPhoneNumber(true);
        axios
            .post(
                "/networkoperatorconsole/shoppingcart/requestSubscription",
                data,
                {
                    headers: { "api-version": "20260417" },
                }
            )
            .then((response) => {
                setCheckingPhoneNumber(false);
                if (response.data.phoneNumberDifferent) {
                    setMismatchPhoneNumber(phoneNumber.trim());
                    setPhoneNumberMismatch(true);
                    return;
                }
                setPhoneNumberMismatch(false);
                sessionStorage.setItem("phoneNumber", phoneNumber.trim());
                if (response.data.getSMSOTP) {
                    history.push("/verification");
                } else if (response.data.StripeClientSecret === undefined) {
                    history.push("/paymentsuccess");
                    noStripeClientSecret = true;
                } else {
                    setClientSecret(response.data.StripeClientSecret);
                    sessionStorage.setItem(
                        "clientSecret",
                        response.data.StripeClientSecret
                    );
                    sessionStorage.setItem(
                        "nextPaymentDate",
                        response.data.NextPaymentDate
                    );
                    sessionStorage.setItem(
                        "proratedPricePerHour",
                        response.data["ProratedPricePerHour.USD"]
                    );
                    sessionStorage.setItem(
                        "unbilledHoursTilNextPaymentDate",
                        response.data.UnbilledHoursTillNextPaymentDate
                    );
                    sessionStorage.setItem(
                        "trialEndDate",
                        response.data.TrialEndDate
                    );
                    sessionStorage.setItem(
                        "firstInvoiceDate",
                        response.data["FirstInvoiceDateUTC.ISO8601"]
                    );
                    setStripePromise(response.data.StripePublishableKey);
                    setState({ billingDetails: response.data });
                    sessionStorage.setItem(
                        "getSMSOTP",
                        response.data.getSMSOTP
                    );
                }
            })
            .catch((error) => {
                setCheckingPhoneNumber(false);
                setState({ errorMessage: error.response.data.message });
            });
    };

    useEffect(() => {
        submitRequestSubscription(sessionStorage.getItem("phoneNumber"));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [history]);

    function submitRetryPhoneNumber(event) {
        event.preventDefault();
        submitRequestSubscription(retryPhoneNumber || "");
    }

    function toggleBillingDetails() {
        setState({
            modalBillingDetails: !state.modalBillingDetails,
        });
    }
    return (
        <>
            {phoneNumberMismatch ? (
                <div className="overlay" style={{ display: "block" }}>
                    <div className="overlayMessage">
                        <p>
                            The phone number, {mismatchPhoneNumber}, does not
                            match the phone number on your account. Please
                            enter the correct phone number.
                        </p>
                        <form
                            className="needs-validation"
                            onSubmit={submitRetryPhoneNumber}
                            noValidate
                        >
                            <PhoneInput
                                placeholder="*Text-Capable Phone Number"
                                value={retryPhoneNumber}
                                onChange={setRetryPhoneNumber}
                                name="retryPhoneNumber"
                                id="retryPhoneNumber"
                                className="form-control"
                                defaultCountry="US"
                                required
                            />
                            <div className="nextButton">
                                <br />
                                <button
                                    className="btn Ripple-parent btn-default"
                                    type="submit"
                                    disabled={
                                        !retryPhoneNumber ||
                                        !isValidPhoneNumber(
                                            retryPhoneNumber
                                        ) ||
                                        checkingPhoneNumber
                                    }
                                >
                                    {checkingPhoneNumber === true ? (
                                        <div
                                            className="spinner-border spinner-border-sm"
                                            role="status"
                                        >
                                            <span className="sr-only">
                                                Loading...
                                            </span>
                                        </div>
                                    ) : (
                                        "Submit"
                                    )}
                                </button>
                                <a
                                    className="btn Ripple-parent btn-default"
                                    href="/"
                                    rel="noreferrer"
                                >
                                    Cancel Sign Up
                                </a>
                            </div>
                        </form>
                    </div>
                </div>
            ) : (
                ""
            )}
            <Suspense
                fallback={
                    <div
                        className="overlay"
                        id="overlay"
                        style={{ display: "block" }}
                    >
                        <div className="overlayMessage">
                            <h3 style={{ color: "#333", marginBottom: "10px" }}>Processing Your Subscription</h3>
                            <p style={{ color: "#666", fontSize: "16px", textAlign: "center", maxWidth: "300px" }}>
                                Please wait while we set up your account and prepare your payment options. This may take a few moments.
                            </p>
                        </div>
                    </div>
                }
            >
                {noStripeClientSecret || phoneNumberMismatch ? (
                    ""
                ) : (
                 <>
                    <CheckOutComponent
                    stripePromise={stripePromise}
                    clientSecret={clientSecret}
                    logo={props.logoLogin}
                    brand={sessionStorage.getItem("brand")}
                    toggleBillingDetails={toggleBillingDetails}
                    modalBillingDetails={state.modalBillingDetails}
                    billingDetails={state.billingDetails}
                    errorMessage={state.errorMessage}
                />
                <Footer />
                </>
                )}
            </Suspense>
        </>
    );
}
